
import React, { useEffect, useState } from "react";
import { useTable, useRowSelect, useMountedLayoutEffect, useSortBy } from "react-table";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        overflow: 'hidden',
        height: '100%',
        minHeight: 0
    },
    table: {
        borderCollapse: 'collapse',
        display: 'flex',
        height: '100%',
        minHeight: 0,
        flexDirection: 'column',
    },
    tableHeadBody: {
        display: 'table',
        width: '99%',
        height: '40px',
        tableLayout: 'fixed',

    },
    tableHeader: {
        borderBottom: '1px solid #D3D3D3',
        textAlign: 'left',
    },
    tBody: {
        flex: '1 1 auto',
        overflow: 'auto',
        display: 'block',
    },
    tableBody: {
        display: 'table',
        width: '100%',
        tableLayout: 'fixed',
        verticalAlign: "middle",
    },
    tableRow: {
        "&:hover": {
            backgroundColor: '#eeeeee ',
        },
        borderTop: '1px solid #D3D3D3',
        "&:last-child": {
            borderBottom: '1px solid #D3D3D3',
        },
        "&:nth-child(even)": {
            backgroundColor: '#f3f3f3',
            "&:hover": {
                backgroundColor: '#eeeeee ',
            },
        }
    },
    tableData: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        userSelect: "none"
    },
    activeRowColor: {
        backgroundColor: "#BCDBF6 !important",
        "&:hover": {
            backgroundColor: '#BCDBF6 !important',
        },
    }
}))

export default function Table(props) {
    const classes = useStyles();

    const { data, columns, selectedIds, onSelectedRowsChange, onActiveRowChanged, activeRowId, onSort, onSortBy } = props;
    const [activeRowIdx, setActiveRowIdx] = useState(null);
    const [shiftPressed, setShiftPressed] = useState(false);
    const [ctrlPressed, setCtrlPressed] = useState(false);
    const [activeId, setActiveId] = useState(null);

    const sorting = {
        id: onSortBy && onSortBy.sortby,
        desc: onSortBy && onSortBy.sortdir === 'desc' ? true : false,
    }

    const {
        getTableProps, // table props from react-table
        getTableBodyProps, // table body props from react-table
        headerGroups, // headerGroups, if your table has groupings
        rows, // rows for the table based on the data passed
        prepareRow,
        toggleAllRowsSelected,
        toggleRowSelected,
        state: { sortBy },
    } = useTable(
        {
            columns,
            data,
            initialState: {
                sortBy: [sorting],
                selectedRowIds: {},
            },
            stateReducer: (newState, action, previousState) => {

                // the table has been reloaded, check which of the selected rows are still visible and check them again
                if (action.type === 'resetSelectedRows') {
                    let activeRowVisible = false;
                    newState.selectedRowIds = {};
                    data.map((row, i) => {
                        if (selectedIds.includes(row.Id)) {
                            newState.selectedRowIds[i] = true;
                        }
                        if (activeRowId === row.Id) {
                            activeRowVisible = true;
                        }
                    });

                    if ((activeRowId !== null) && !activeRowVisible) {
                        //alert("not visible");
                        setActiveRowIdx(null);
                        onActiveRowChanged(null);
                    }

                    // also, check if the active report is still visible. If not, remove the active state

                    

                    // the selection might have changed, inform the parent
                    let selectedRows = [];
                    Object.keys(newState.selectedRowIds).map(i => {
                        selectedRows.push(data[i])
                    });
                    onSelectedRowsChange(selectedRows || []);

                }


                if ((action.type === 'toggleRowSelected') || (action.type === 'toggleAllRowsSelected')) {
                    let oldActiveRowIdx = activeRowIdx;
                    let newActiveRowIdx = activeRowIdx;
                    let oldIds = Object.keys(previousState.selectedRowIds);
                    let newSelectedIndex = null;

                    // a single row has been either checked or clicked
                    if (action.type === 'toggleRowSelected') {
                        if (action.value === true) {    // a new checkbox has been checked
                            newSelectedIndex = action.id;
                            newActiveRowIdx = action.id;
                        }
                        if (action.value === "rowclick") {
                            // a row has clicked, find out whehter it has been selected or de-selected
                            let clickedSelectedRow = oldIds.includes(action.id.toString());

                            // remove selection in case neither shift nor ctrl has been pressed
                            if (!ctrlPressed && !shiftPressed) {
                                newState.selectedRowIds = {};
                            }

                            // toggle the selection of the clicked row
                            if (clickedSelectedRow) {
                                delete newState.selectedRowIds[action.id];
                            } else {
                                newState.selectedRowIds[action.id] = true;
                                newSelectedIndex = action.id;
                                newActiveRowIdx = action.id;
                            }
                        }

                        // handle shift pressed: select rows between last selection and latest selection
                        if (shiftPressed && (newSelectedIndex !== null)) {
                            let firstSelectedIndex = parseInt(oldIds[0]);
                            let lastSelectedIndex = parseInt(oldIds[oldIds.length - 1]);
                            let filledIdx = {};
                            if (newSelectedIndex < firstSelectedIndex) { // a new row has been selected before the previous selection
                                for (let i = newSelectedIndex + 1; i < firstSelectedIndex; i++) {
                                    filledIdx[i] = true;
                                }
                            } else {
                                for (let i = lastSelectedIndex + 1; i < newSelectedIndex; i++) {
                                    filledIdx[i] = true;
                                }
                            }
                            newState.selectedRowIds = { ...newState.selectedRowIds, ...filledIdx };
                        }
                    }

                    // no more rowse are selected, also reset the active row
                    if (Object.keys(newState.selectedRowIds).length === 0) {
                        newActiveRowIdx = null;
                    } // some selected rows remain, activate the first
                    else if (newActiveRowIdx && !Object.keys(newState.selectedRowIds).includes(newActiveRowIdx.toString())) {
                        newActiveRowIdx = Object.keys(newState.selectedRowIds)[0];
                    }

                    // active row has changed, inform the parent about the change
                    if (newActiveRowIdx !== oldActiveRowIdx) {
                        if (newActiveRowIdx === null) {
                            setActiveRowIdx(null);
                            onActiveRowChanged(null);
                        } else {
                            setActiveRowIdx(newActiveRowIdx);
                            onActiveRowChanged(data[newActiveRowIdx]);
                        }
                    }

                    // also selection has likely changed, inform the parent
                    let selectedRows = [];
                    // eslint-disable-next-line 
                    Object.keys(newState.selectedRowIds).map(i => {
                        selectedRows.push(data[i])
                    });
                    onSelectedRowsChange(selectedRows);
                }


            },
            manualSortBy: true,
            disableSortRemove: true,
            manualPagination: true,
            autoResetRowState: false,
            autoResetSortBy: false
        },
        useSortBy,
        useRowSelect,
    );

    useMountedLayoutEffect(() => {
        onSort(sortBy);
    }, [sortBy]);


    // handle active row has been changed by clicking on it
    const onRowActive = (row, i, e) => {
        toggleRowSelected(i, "rowclick");
        return false;
    }

    // select all rows if Ctrl+A has been pressed
    const handleKeyPress = (e) => {
        if (e.ctrlKey && (e.keyCode === 65 || e.keyCode === 97)) {
            e.preventDefault();
            toggleAllRowsSelected(true);
            return false;
        }

        if (e.shiftKey) {
            setShiftPressed(true);
            return false;
        }

        if (e.ctrlKey) {
            setCtrlPressed(true);
            return false;
        }

    }

    const handleKeyUp = (e) => {
        setShiftPressed(false);
        setCtrlPressed(false);
    }

    // Register key down handler for Ctrl+A handling
    useEffect(() => {
        document.addEventListener("keydown", handleKeyPress, false);
        document.addEventListener("keyup", handleKeyUp, false);
        return () => {
            document.removeEventListener("keydown", handleKeyPress, false);
            document.removeEventListener("keyup", handleKeyUp, false);
        };
    }, []);



    return (
        <div className={classes.root}>
            <table {...getTableProps()} className={classes.table}>

                <thead className={classes.tableHeadBody}>
                    {headerGroups.map(headerGroup => (
                        <tr className={classes.tableHeader}
                            {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map(column => (
                                <th className={`${classes.tableData} ${column.headerClassName}`} {...column.getHeaderProps(column.getSortByToggleProps())}>
                                    <span>
                                        {column.isSorted
                                            ? column.isSortedDesc
                                                ? "🔽 "
                                                : "🔼 "
                                            : ""}
                                    </span>
                                    {column.render("Header")}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>

                <tbody className={classes.tBody} {...getTableBodyProps()}>
                    {rows.map((row, i) => {
                        prepareRow(row);
                        return (
                            <tr onClick={(e) => onRowActive(row, i, e)} className={`${(activeRowId !== null) && activeRowId === row.original.Id ? classes.activeRowColor : ''} ${classes.tableBody} ${classes.tableRow}`}
                                {...row.getRowProps()}>
                                {row.cells.map(cell => {
                                    return <td className={`${classes.tableData} ${cell.column.cellClassName}`} {...cell.getCellProps()}> {cell.render("Cell")} </td>;
                                })}
                            </tr>
                        );
                    })}
                </tbody>

            </table>

        </div>
    );
}
